import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { DirectDebitCollectionDayModel } from "services/api/cplapi/CPLAPI";
import { IDirectDebitCollectionDaysService } from "services/DirectDebitCollectionDaysService";
import { RootState } from "setup";
import { container } from "setup/dependency/inversify.config";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";

type DirectDebitCollectionDaysState = {
  DirectDebitCollectionDays: Array<DirectDebitCollectionDayModel>;
  Loading: boolean;
  Updating: boolean;
};

const initialState: DirectDebitCollectionDaysState = {
  DirectDebitCollectionDays: new Array<DirectDebitCollectionDayModel>(),
  Loading: false,
  Updating: false,
};

export const directDebitCollectionDaysSlice = createSlice({
  name: "DirectDebitCollectionDays",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDirectDebitCollectionDays.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getDirectDebitCollectionDays.fulfilled, (state, action) => {
        state.DirectDebitCollectionDays = action.payload;
        state.Loading = false;
      })
      .addCase(getDirectDebitCollectionDays.rejected, (state) => {
        state.Loading = false;
      })
      .addCase(updateDirectDebitCollectionDays.pending, (state) => {
        state.Updating = true;
      })
      .addCase(updateDirectDebitCollectionDays.fulfilled, (state) => {
        state.Updating = false;
        toast.success("Direct Debit Collection Days Updated");
      })
      .addCase(updateDirectDebitCollectionDays.rejected, (state) => {
        state.Updating = false;
        toast.success("Direct Debit Collection Days failed to update");
      });
  },
});

export const getDirectDebitCollectionDays = createAsyncThunk(
  "DirectDebitCollectionDays/GetDirectDebitCollectionDays",
  async () => {
    const directDebitCollectionDaysService = container.get<IDirectDebitCollectionDaysService>(
      SERVICE_TYPES.DirectDebitCollectionDaysService
    );
    return await directDebitCollectionDaysService.getDirectDebitCollectionDays();
  }
);

export const updateDirectDebitCollectionDays = createAsyncThunk(
  "DirectDebitCollectionDays/UpdateDirectDebitCollectionDays",
  async (allowedDays: number[], thunkAPI) => {
    const directDebitCollectionDaysService = container.get<IDirectDebitCollectionDaysService>(
      SERVICE_TYPES.DirectDebitCollectionDaysService
    );
    await directDebitCollectionDaysService.updateAllowedCollectionDays(allowedDays);
    thunkAPI.dispatch(getDirectDebitCollectionDays());
  }
);

export const selectDirectDebitCollectionDays = (state: RootState) =>
  state.directDebitCollectionDays.DirectDebitCollectionDays;
export const selectLoading = (state: RootState) => state.directDebitCollectionDays.Loading;
export const selectUpdating = (state: RootState) => state.directDebitCollectionDays.Updating;

export default directDebitCollectionDaysSlice.reducer;
